module.exports = __webpack_public_path__ + "ux-test.svg?1fd2bf9949909e0b45d6abfaef89adf3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ux-test.svg
// module id = 128
// module chunks = 0